<template>
  <div class="page">
    <div></div>
    <div v-for="(item, index) in columnInfo" :model="pageData" :key="index">
      <div>
        <!-- <div v-if="item.id !== 1051003"> -->
        <el-form-item :required="item.required" v-if="item.uiType == 1">

          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>

          <el-input maxlength="240" :style="input_width" v-model="pageData[item.index]" :disabled="!item.editable"
            @input="upInput(item.index, item.id)" @blur='emitInput(item.index, item.id)'></el-input>
        </el-form-item>
        <!-- </div> -->

      </div>

      <div>
        <el-form-item :required="item.required" v-if="item.uiType == 2">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-input maxlength="4000" show-word-limit type="textarea" :style="input_width" :disabled="!item.editable"
            v-model="pageData[item.index]" @input="upInput(item.index, item.id)" @blur='emitInput(item.index, item.id)'>
          </el-input>
        </el-form-item>
      </div>

      <div>
        <el-form-item v-if="item.uiType == 3" :required="item.required">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-cascader clearable v-if="item.listType == 2" :style="input_width" v-model="pageData[item.index]"
            :options="item.listEntrie" :show-all-levels="true" :props="{ checkStrictly: true }"
            @change="upCascadeList(item.index, item.id)">
          </el-cascader>
          <el-select v-else-if="item.id == 1092004" v-model="pageData[item.index]"
            :placeholder="$t('message.placeholder.select')" :style="input_width" :disabled="!item.editable"
            @change="upSimpleList(item.index, item.id)">
            <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie" :key="items.id">
            </el-option>
          </el-select>
          <el-select v-else v-model="pageData[item.index]" clearable :placeholder="$t('message.placeholder.select')"
            :style="input_width" :disabled="!item.editable" @change="upSimpleList(item.index, item.id)">
            <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie" :key="items.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div>
        <el-form-item v-if="item.uiType == 4" :required="item.required">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-cascader v-if="item.listType == 2" :style="input_width" v-model="casMultiData[item.index]"
            :options="item.listEntrie" :props="multi" :show-all-levels="true"
            @change="upCascadeMultiList(item.index, item.id)">
          </el-cascader>
          <el-select v-else v-model="pageData[item.index]" :placeholder="$t('message.placeholder.select')"
            :style="input_width" :disabled="!item.editable" multiple @change="upMultiList(item.index, item.id)">
            <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie" :key="items.index">
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div>
        <el-form-item v-if="item.uiType == 6" :required="item.required">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-date-picker v-if="item.id == 1051001 || item.id == 1051002" @change="upDateTime(item.index, item.id)"
            :style="input_width" v-model="pageData[item.index]" type="date"
            :placeholder="item.editable ? $t('message.placeholder.pickDate') : ''" :disabled="!item.editable"
            :picker-options="pickerOptions">
          </el-date-picker>
          <el-date-picker v-else @change="upDateNormallTime(item.index, item.id)" :style="input_width"
            v-model="pageData[item.index]" type="date"
            :placeholder="item.editable ? $t('message.placeholder.pickDate') : ''" :disabled="!item.editable">
          </el-date-picker>
        </el-form-item>
      </div>

      <div>
        <el-form-item :required="item.required" v-if="item.uiType == 7">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <!-- <el-input :style="input_width" :disabled="item.required"></el-input> -->
          <el-input v-if="item.id == 1051003" maxlength="240" :style="input_width" v-model="duration"
            :disabled="!item.editable" @input="editDateVal(item.index, item.id)"
            @blur='emitDateVal(item.index, item.id)'>
          </el-input>
          <el-input v-else :style="input_width" v-model="pageData[item.index]" @input="upInput(item.index, item.id)"
            @blur='emitInput(item.index, item.id)' :disabled="!item.editable">
          </el-input>

          <!-- <el-input  maxlength="240" :style="input_width" :disabled="!item.editable" @input="upInput(item.index,item.id)" @blur='emitInput(item.index,item.id)'>
          </el-input> -->

        </el-form-item>
      </div>
      <div>

        <el-form-item :required="item.required" v-if="item.uiType == 10">
          <span slot="label">
            <el-tooltip v-if="item.descriptions.length" effect="dark" placement="top-start">
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
            </el-tooltip>
            <span :title="item.name">{{ item.name }}</span>
          </span>
          <el-input :style="input_width" v-model="pageData[item.index]" @input='costInput(item.index)'
            @blur="upCurrency(item.index)" :readonly='item.id == 1051046 || item.id == 1051047'
            :disabled="!item.editable">
            <!-- <span style="margin:0 5px" slot="prefix" >{{"￥ " + " "}} </span> -->
            <span slot="append">{{ "￥ " + $t('message.table.currency') }} </span>
            <!-- <el-select
              v-model="currencyIdList[item.index]"
              slot="append"
              :placeholder="$t('message.placeholder.select')"
              @change="upCurrencyId(item.index)"
              :disabled="!item.editable"
            >
              <el-option
                v-for="items in item.listEntrie"
                :label="items.name"
                :value="items.id"
                :key="items.id"
              ></el-option>
            </el-select> -->
          </el-input>
        </el-form-item>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mData: "",
      pageInfo: {},
      columnInfo: [],
      pageData: [],
      subData: {},
      input_width: {
        width: "50%",
      },

      duration: '',
      editAllTime: [],
      budgetedCosts: [],
      actualCosts: [],
      currencyIdList: [],

      cascadeList: [],
      cascadeMultiList: [],

      calendarList: [],
      cList: [],
      multi: {
        multiple: true,
        checkStrictly: true,
      },
      // typeList: [1051009],
      nameList: [1051016, 1051017],
      resetNum: "",
      nameId: "",
      basicData: {},
      // defaultTime:'23:59:59',
      pickerOptionsStart: {
        // disabledDate: (time) => {
        //   const et = this.columnInfo.find(
        //     (i) => i.id == 1051002
        //   ).index;
        //   return (
        //     time.getTime() > Date.parse(this.pageData[[et]])
        //     // ||
        //     // time.getDay() == 0 ||
        //     // time.getDay() == 6
        //   );
        // },
        cellClassName: (time) => this.calendarDate(time)
      },
      pickerOptions: {
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time)
      },
    };
  },

  props: ["page", "pageIndex", "pageId", "reset"],
  methods: {
    getColumn() {
      let column = this.getNewData(this.page.object.columnInfo).filter(
        (i) => i.required || i.defaultValue !== ""
      );
      this.editAllTime = [];
      this.budgetedCosts = [];
      this.actualCosts = [];
      const costList = [1051036, 1051037, 1051038, 1051039, 1051040, 1051041, 1051042, 1051043, 1051044, 1051045, 1051046, 1051047]
      column.map((i, e) => {
        i.index = e;
        if (i.id == 1051009) {
          i.editable = false;
          i.listType = 1;
          i.listEntrie = [
            {
              id: this.pageId.id,
              name: this.pageId.name,
            },
          ];
          // this.pageData[i.id] = this.pageId.id;
          this.pageData[e] = i.listEntrie[0].id;
          this.subData[i.id] = this.pageData[e];
        }


        if (i.id == 1051001 || i.id == 1051002) {
          let t = new Date();
          console.log(t);
          this.pageData[e] = new Date(Date.parse(t.toDateString()) + -t.getTimezoneOffset() * 60 * 1000);
          console.log(this.pageData[e]);
          this.subData[i.id] = this.pageData[e];
        }

        if (i.id == 1051003) {
          this.pageData[e] = 1;
          this.subData[i.id] = 8 * 60 * 60 * 1000
        }

        if (i.uiType == 10) {
          console.log(i);
          // this.currencyIdList[i.index] =  JSON.stringify(arr[e].currencyCode) == "{}" ? '' : arr[e].currencyCode +''
          costList.filter((_, e) => (e % 2)).includes(parseInt(i.id)) && this.budgetedCosts.push(i.index);
          costList.filter((_, e) => !(e % 2)).includes(parseInt(i.id)) && this.actualCosts.push(i.index);

        }
      });
      this.getDefaultValues(column);
      // this.$emit("update:change", this.pageData);

      this.columnInfo = column.filter((i) => i.required);
      console.log(this.columnInfo);
      this.upData();
    },
    getCalendar() {
      this.$http.get("/ppm/calendar/loadCalendar?year=" + new Date().getFullYear()).then(
        res => {
          console.log(res);
          this.calendarList = res.data.object;
          this.cList = this.calendarList.map(i => i.exceptionDate.split('T')[0]);
          console.log(this.cList);
        }
      )
    },
    calendarDate(time) {
      if (this.cList.includes(this.getLocalTime(time.getTime()))) {
        if ([0, 6].includes(time.getDay())) {
          return 'date-pick-workday'
        } else {
          return 'date-pick-holiday'
        }
      }
      if ([0, 6].includes(time.getDay()) && !this.cList.includes(this.getLocalTime(time.getTime()))) {
        return 'date-pick-holiday'
      }
    },
    getDefaultValues(data) {
      // if (i.defaultValue) {
      //     this.pageData[i.index] = i.defaultValue;
      //     console.log(i.defaultValue,i.index);
      //   }
      const arr = data.filter((i) => !!i.defaultValue);
      arr.map((i) => {
        console.log(i);
        // const e = this.columnInfo.find(item =>item.index == i.index).id;
        const e = i.id;
        this.subData[e] = this.pageData[i.index];
        if (i.uiType == 3 && i.listType == 2) {
          let val_ = i.defaultValue.split(",");
          val_ = val_[0].split(";");
          let searchVal_ = val_[val_.length - 1];
          this.subData[i.id] = searchVal_;
          this.pageData[i.index] = this.getParentIdListByPid(
            i.listEntrie,
            searchVal_
          );
          // this.subData[i.id] = this.pageData[i.index]
        } else if (i.uiType == 4) {
          if (i.listType == 2) {
            let Val_ = i.defaultValue.split(";");
            let searchVal_ = [];
            Val_.map((i) => {
              let val = i.split(",");
              searchVal_.push(val[val.length - 1]);
            });
            this.subData[i.id] = searchVal_.join(";");
            this.pageData[i.index] = searchVal_.map((j) => {
              return this.getParentIdListByPid(i.listEntrie, j);
            });
          }
          if (i.listType == 1 || !i.listType) {
            this.subData[i.id] = i.defaultValue;
            this.pageData[i.index] = i.defaultValue.split(";");
          }
        } else if (i.uiType == 10) {
          this.subData[i.id] = parseFloat(i.defaultValue).toFixed(2);
          this.pageData[i.index] = parseFloat(i.defaultValue).toFixed(2);
        } else {
          this.subData[i.id] = i.defaultValue;
          this.pageData[i.index] = i.defaultValue;
        }
        //console.log(this.columnInfo);
        //const e = this.columnInfo.find(item =>item.index == i.index).id;
        // this.subData[e] = this.pageData[i.index];
        //console.log(this.subData);
      });
    },

    upInput(i, e) {
      this.$forceUpdate();

    },

    editDateVal(i, e) {
      this.$forceUpdate();
      this.duration = Number(this.duration.substr(0, 6).replace(/[^0-9]/g, '')) || '';
    },
    emitDateVal() {
      const st = this.columnInfo.find((i) => i.id == 1051001).index;
      const et = this.columnInfo.find((i) => i.id == 1051002).index;

      if (this.duration) {
        if (this.pageData[st] || this.pageData[et]) {
          let day = !this.pageData[st] ? this.countStartDate(this.duration, this.pageData[et]) : this.countEndDate(this.duration, this.pageData[st]);
          const tempId = !this.pageData[st] ? 1051001 : 1051002;
          const tempIndex = !this.pageData[st] ? st : et;
          this.$set(this.pageData, tempIndex, day)
          this.$set(this.subData, tempId, day)
        }
      }
      this.subData["1051003"] = this.duration * 8 * 60 * 60 * 1000 || '';
      this.upData();
    },
    emitInput(i, id) {
      let n = this.pageData[i];
      let m = id || this.columnInfo.find(item => item.index == i).id;

      this.subData[m] = !n ? '' : n.trim();
      this.upData();
    },
    upDateTime(i, id) {
      let t = this.pageData[i];
      const st = this.columnInfo.find((i) => i.id == 1051001).index;
      const et = this.columnInfo.find((i) => i.id == 1051002).index;

      const tempId = id == 1051001 ? 1051002 : 1051001;
      const tempIndex = i == st ? et : st;

      if (t) {
        this.pageData[i] = new Date(Date.parse(t) + -t.getTimezoneOffset() * 60 * 1000);
        if (st == i && this.pageData[i] > this.pageData[et]) {
          this.$set(this.pageData, et, '');
        }
        if (et == i && this.pageData[i] < this.pageData[st]) {
          this.$set(this.pageData, st, '')
        }

        if (this.duration) {
          let day = id == 1051001 ? this.countEndDate(this.duration, this.pageData[i]) : this.countStartDate(this.duration, this.pageData[i]);
          this.$set(this.pageData, tempIndex, day)
          this.$set(this.subData, tempId, day)
        } else {
          if (!this.pageData[tempIndex]) {
            this.subData[id] = '';
            this.duration = '';
            this.subData['1051003'] = '';
          } else {
            let n = this.countWorkDay(this.pageData[st], this.pageData[et])
            this.duration = n;
            this.subData['1051003'] = n * 8 * 60 * 60 * 1000;
          }
        }
      }
      this.subData[id] = this.pageData[i];
      this.upData();
    },
    upDateNormallTime(i, id) {
      this.subData[id] = this.pageData[i];
      this.$forceUpdate();
      this.upData();
    },
    upCascadeList(i, id) {
      this.$forceUpdate();
      // console.log(this.pageData[i]);
      let n = this.pageData[i];
      // console.log(n);
      this.subData[id] = !n ? "" : n[n.length - 1];
      this.upData();
    },


    upSimpleList(i, id) {
      this.$forceUpdate();
      let n = this.pageData[i];
      this.subData[id] = n || "";
      this.upData();
    },
    upMultiList(i, id) {
      this.$forceUpdate();
      let n = this.pageData[i];
      this.subData[id] = this.arrSort(n);
      this.upData();
    },
    upCascadeMultiList(i, id) {
      // console.log(this.casMultiData[i]);
      // console.log(this.pageData[i]);
      let n = this.deepCopy(this.casMultiData[i]);
      this.subData[id] = n.length > 0 ? this.arrSort(n.map(this.arrLast)) : "";
      this.upData();
    },

    upCurrencyId(i) {
      console.log(this.columnInfo);
      const currencyId = this.columnInfo.find(item => item.index == i).id + '_01';
      console.log(this.currencyIdList[i]);
      this.subData[currencyId] = this.currencyIdList[i];
      this.$forceUpdate();
      this.upData();
    },
    costInput(i) {
      // // console.log(i);
      const bc = this.columnInfo.find((i) => i.id == 1051047)?.index;
      const ac = this.columnInfo.find((i) => i.id == 1051046)?.index;
      let costConvolution = (arr) => {
        let sum = 0;
        for (let i = 0, j = arr.length - 1; i < j; i++) {
          sum += parseInt(this.pageData[arr[i]]) || 0;
        }
        return sum;
      };

      let n = this.pageData[i];
      if (!Number(n)) {
        this.pageData[i] = '';
      }
      this.pageData[i] = n.replace(/[^0-9.]/g, '');

      if (this.budgetedCosts.includes(i) && bc) {
        this.pageData[bc] = costConvolution(this.budgetedCosts);
        this.subData['1051047'] = parseFloat(this.pageData[bc]).toFixed(2)
      }
      if (this.actualCosts.includes(i) && ac) {
        this.pageData[ac] = costConvolution(this.actualCosts)
        this.subData['1051046'] = parseFloat(this.pageData[ac]).toFixed(2)
      }

      this.$forceUpdate();
      this.emitInput(i);
    },
    upCurrency(i) {
      let n = parseFloat(this.pageData[i]).toFixed(2);
      n = isNaN(n) ? '' : n
      const m = this.columnInfo.find(item => item.index == i).id;
      this.$set(this.pageData, i, n)
      this.subData[m] = n;
      // if (!this.currencyIdList[i]) {
      //   const currencyId = m + '_01';
      //   const defaultCurrency = this.columnInfo.find(item =>item.index == i).listEntrie[0].id;
      //   // this.currencyIdList[i] = defaultCurrency;
      //   this.subData[currencyId] =  defaultCurrency;
      // }
      this.upData()
    },

    arrLast(n) {
      n = n.length > 0 ? n[n.length - 1] : "";
      return n;
    },
    arrSort(n) {
      n = n.length > 0 ? n.sort((a, b) => a - b).join(";") : "";
      return n;
    },

    upData() {

      this.isReq = !this.columnInfo.some(
        (i) => !this.subData[i.id] || this.subData[i.id] == ""
      );
      // this.isReq = !Object.values(m).includes('');
      // console.log(this.isReq);
      // console.log(this.subData);
      this.$emit("update:change", this.subData);
      this.$emit("update:checkReq", this.isReq);
    },

  },
  mounted() {
    this.upData();
  },
  created() {
    this.getColumn();
    !this.pageIndex && this.getCalendar();
  },
  watch: {
    reset() {
      this.pageData = [];
      this.subData = {};
      this.duration = '';
      this.getColumn();

    },
    // getMFInfo(){
    //   console.log('!!!!!!!!');
    // }
  },
};
</script>
<style>
/* .date-pick-workday span {
  color: #fff;
  background: #f56c6c;
   border-radius: 12px;
} */
.date-pick-holiday span {
  color: #fff;
  background: #a0cfff;
  border-radius: 8% !important;
}
</style>

<style scoped>
.page {
  margin-top: 15px;
}
</style>